// extracted by mini-css-extract-plugin
export default {"container":"EventPeriod_container__GOTJn"};